import React, { useEffect, useState } from 'react';
import { Chip, Typography } from '@mui/material';
import TranslateOutlined from '@mui/icons-material/TranslateOutlined';
import { useNavigate } from 'react-router-dom';
import type { FamilyMember } from '../../services/variantService';

// Dynamic import keeps axios (ESM) out of the player/catalog test graphs (same pattern as HelpBotWidget).
const service = async () => (await import('../../services/variantService')).variantService;

/**
 * "Auch verfügbar in …" (Tranche E2, #489): other members of a course family
 * the learner may open. Renders nothing for courses without variants.
 */
/** `label` comes from the parent (the course player has no translation hook); defaults to the German UI text. */
export const AvailableInChips: React.FC<{ courseId: number; linkTo?: (id: number) => string; onSelect?: (id: number) => void; compact?: boolean; label?: string }> = ({ courseId, linkTo, onSelect, compact, label = 'Auch verfügbar in' }) => {
    const navigate = useNavigate();
    const [others, setOthers] = useState<FamilyMember[]>([]);

    useEffect(() => {
        let cancelled = false;
        service().then((svc) => svc.family(courseId))
            .then((family) => { if (!cancelled) setOthers(family.variants.filter((m) => !m.isCurrent && m.isActive)); })
            .catch(() => { if (!cancelled) setOthers([]); });
        return () => { cancelled = true; };
    }, [courseId]);

    if (others.length === 0) return null;

    return (
        <div className="oa-available-in" data-testid="available-in" style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
            {!compact && <Typography variant="caption" color="text.secondary" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}><TranslateOutlined fontSize="inherit" /> {label}</Typography>}
            {others.map((m) => (
                <Chip key={m.id} size="small" clickable label={m.nativeLabel} title={m.title} onClick={(e) => { e.stopPropagation(); if (onSelect) onSelect(m.id); else navigate(linkTo ? linkTo(m.id) : `/course-player/${m.id}`); }} />
            ))}
        </div>
    );
};

export default AvailableInChips;
